import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmPlay = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-play",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-play",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      fill: "currentColor",
      d: "M25.5,11.3c0.4,0.2,0.7,0.6,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.3s-0.1,0.9-0.3,1.3c-0.2,0.4-0.6,0.7-0.9,0.9L7.5,26 c-0.4,0.2-0.8,0.3-1.3,0.3S5.3,26.2,4.9,26c-0.4-0.2-0.7-0.6-0.9-0.9c-0.2-0.4-0.3-0.8-0.3-1.3V3.2c0-0.5,0.1-0.9,0.3-1.3 c0.2-0.4,0.5-0.7,0.9-1c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,0.9,0.1,1.3,0.3L25.5,11.3z"
    })
  }));
});
IconLlmPlay.displayName = 'IconLlmPlay';

export { IconLlmPlay };
//# sourceMappingURL=llm-play.js.map
